import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import EditCustomTagsPopover from '@modules/custom-tags/components/EditCustomTagsPopover'
import { ShortlistSortOrder } from '@modules/shortlist/types'
import ModeIcon from '@mui/icons-material/Mode'
import { Box, Typography } from '@mui/material'

import SortArrow from './SortArrow'

export interface ProfileTitleHeadCellProps {
  showEditCustomTagsPopup: boolean
  setShowEditCustomTagsPopup: (edit: boolean) => void
  sortOrder?: ShortlistSortOrder
  activeShortlistId: number
  isSortActive: boolean
}

const ProfileTitleHeadCell = ({
  showEditCustomTagsPopup,
  setShowEditCustomTagsPopup,
  sortOrder,
  isSortActive,
  activeShortlistId,
}: ProfileTitleHeadCellProps) => {
  const { t } = useTranslation()
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ cursor: 'pointer', flex: '1', alignItems: 'center' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Typography variant="h3">
        {t(translationKeys.CUSTOM_LIST_TABLE_HEADER_CUSTOM_TAG)}
        {showEditCustomTagsPopup && (
          <Box
            onMouseUp={e => {
              e.stopPropagation()
            }}
            onClick={e => {
              e.stopPropagation()
            }}
          >
            <EditCustomTagsPopover
              isOpen={showEditCustomTagsPopup}
              onClose={() => setShowEditCustomTagsPopup(false)}
              activeShortlistId={activeShortlistId}
            />
          </Box>
        )}
      </Typography>
      <ModeIcon
        sx={{ cursor: 'pointer', paddingLeft: '4px' }}
        fontSize="small"
        color="primary"
        onMouseUp={e => {
          e.stopPropagation()
        }}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          setShowEditCustomTagsPopup(true)
        }}
      />
      <SortArrow isActive={isSortActive} order={isSortActive ? sortOrder : null} isHovered={isHovered} />
    </Box>
  )
}

export default memo(ProfileTitleHeadCell)
